import styled from 'styled-components';

import { spaceXXL } from '@xingternal/tokens';
import { BodyCopy as BodyCopyComponent } from '@xingternal/typography';

export const BodyCopy = styled(BodyCopyComponent)`
  margin-bottom: ${spaceXXL};
`;
